import {SizeStock} from "@/components/shop/SizeSelector";

const orderedSizes = [
  '2-3',
  '4-5Y',
  '6-7Y',
  '8-9Y',
  '10-11Y',
  '12-13Y',
  '13Y',
  '2-4y',
  '5-8y',
  '8-10y',
  '8-10 y',
  '9-11y',
  '13y',
  'XS',
  'S',
  'M',
  'L',
  'XL',
  '2XL',
];

export const sortSizes = <T extends { sizeName: string | null }>(sizes: T[]) => {
  return sizes.sort((a, b) => {
    const indexA = orderedSizes.findIndex(name =>
      name.toLowerCase() === a.sizeName?.toLowerCase()
    );
    const indexB = orderedSizes.findIndex(name =>
      name.toLowerCase() === b.sizeName?.toLowerCase()
    );

    return indexA - indexB;
  });
};
